// extracted by mini-css-extract-plugin
export default {"Header":"styles_Header__35qmn","Header-logo":"styles_Header-logo__ywgJ0","Header-items":"styles_Header-items__Ba1wa"};